import { ASTFragment } from "../fragment";
import { ASTFragmentCursor } from "./node_cursor";
import { ASTNode } from "../nodes/ast-node";
import { Cursor } from "@tab-edit/model";

export class ASTCursor implements Cursor<ASTNode> {
    private currentCursor: ASTFragmentCursor;
    private constructor(
        private fragSet: ASTFragment[],
        private pointer: number = 0,
    ) {
        this.currentCursor = new ASTFragmentCursor(fragSet[pointer]);
    }
    public static from(fragSet: ASTFragment[], startingPos?: number) {
        return new ASTCursor(fragSet, startingPos || 0);
    }
    get name() { return this.currentCursor.name }
    get node() { return this.currentCursor.node }
    getAncestors() { return this.currentCursor; }
    firstChild() { return this.currentCursor.firstChild() }
    lastChild() { return this.currentCursor.lastChild() }
    parent() { return this.currentCursor.parent() }
    prevSibling() {
        if (!this.currentCursor.fork().parent() && this.pointer>0) {
            this.pointer = this.pointer-1;
            this.currentCursor = new ASTFragmentCursor(this.fragSet[this.pointer]);
            return true;
        }
        return this.currentCursor.prevSibling();
    }
    nextSibling() {
        if (!this.currentCursor.fork().parent() && this.pointer+1 < this.fragSet.length) {
            this.pointer = this.pointer+1;
            this.currentCursor = new ASTFragmentCursor(this.fragSet[this.pointer]);
            return true;
        }
        return this.currentCursor.nextSibling();
    }
    fork() { 
        const copy = new ASTCursor(this.fragSet, this.pointer);
        copy.currentCursor = this.currentCursor;
        return copy;
    }
}
